import * as CryptoJS from 'crypto-js';


export class EncryptionService 
{
    encodeURIComponentFull(str: string): string 
    {
        str = encodeURIComponent(str);
      
        str = str.replace('(', '%28');
        str = str.replace(')', '%29');
        str = str.replace('*', '%29');
        str = str.replace('!', '%21');
        str = str.replace('~', '%7E');
        str = str.replace('\'','%27');
        str = str.replace('/', '%2F');
        str = str.replace('=', '%3D');
        str = str.replace('+', '%2B');
      
        return str;
      }
      LocalPassGenerator() 
      {
        let MyTime: Date = new Date();
        let Month, Day, Hours,sec,mi,y : number;
        Month = MyTime.getMonth() + 1;   //The getMonth() method returns the month (from 0 to 11)
        Day = MyTime.getDate();
        Hours = MyTime.getHours();
        sec =MyTime.getSeconds();
        mi=MyTime.getMilliseconds();
        y=MyTime.getFullYear();
        let MyDate= y.toString() + Month.toString() + Day.toString();
        let SecurityPass: string = "Parsic;" + sec + ";Hbb;" + mi + ";!@#;" + MyDate + ";Raz;" + MyDate + sec + mi;
       
        return SecurityPass.toString();
      }
      
     
      encryptUsingAES256() 
      {
        
         let key = CryptoJS.enc.Utf8.parse('PO/tZSIXMYJ0iRWRsaprfItDPEFZQUKl');
        let iv = CryptoJS.enc.Utf8.parse('@!!sahragard!!&&');
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.LocalPassGenerator()),key, 
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
       
        //this.decryptUsingAES256(encrypted);
        console.log('MyPassword',this.encodeURIComponentFull(encrypted.toString()))
        return this.encodeURIComponentFull(encrypted.toString())
      }
}
